export const USERS_PAGE = {
    'USERS.PAGE.TITLE': 'Utilizatori',
    'USER.ADD.MODAL.TITLE': 'Utilizator nou',
    'USER.EDIT.MODAL.TITLE': 'Editare utilizator',
    'USER.DISPLAY.MODAL.TITLE': 'Detalii utilizator'
};
